import { Close, Edit, Check, Task } from "@mui/icons-material";
import { Icon, Typography } from "@mui/material";
import { ARUniEntryRequestStatus } from "../../../../../../utils/constants";

const ARUniEntryRequestStatusIcon = ({ status }) => {
  let icon = null;
  let color = "primary";
  if (status.id === ARUniEntryRequestStatus.DRAFT) {
    icon = <Edit />;
  } else if (status.id === ARUniEntryRequestStatus.SUBMITTED) {
    icon = <Task />;
  } else if (status.id === ARUniEntryRequestStatus.ACCEPTED) {
    icon = <Check />;
    color = "green";
  } else if (status.id === ARUniEntryRequestStatus.REJECTED) {
    icon = <Close />;
    color = "red";
  }

  return (
    <Typography color={color}>
      <Icon title={status.name}>{icon}</Icon>
    </Typography>
  );
};
export default ARUniEntryRequestStatusIcon;
